import React, { useEffect, useMemo, useRef, useState } from "react";
import useNotificationContainer from "../../../hooks/useNotificationContainer";
import * as Styles from "../../../styles/v2/lexus/components/Notification";
import { getReachoutSidepanelSize } from "../../../utils";

/**
 * TODO: OR-8911 - Support different variants for the notifications
 */
const NotificationContainer = (): JSX.Element => {
    const { notifications, onTransitionEnd } = useNotificationContainer();
    const refs = useRef<(HTMLDivElement | null)[]>([]);

    const reachoutSidepanelWidth = getReachoutSidepanelSize();
    const [notificationHeights, setNotificationHeights] = useState<number[]>([]);

    useEffect(() => {
        refs.current = refs.current.slice(0, notifications.length);

        setNotificationHeights(
            notifications.map((_, index) => {
                return refs.current[index]?.clientHeight ?? 0;
            }),
        );
    }, [notifications, refs]);

    const getHeight = (index: number): number => {
        let height = 0;
        const gap = 20;
        for (let notificationIndex = 0; notificationIndex < index; notificationIndex++) {
            const previousHeight = notificationHeights[notificationIndex];
            if (previousHeight) height += previousHeight + gap;
        }
        return height;
    };

    return useMemo(
        () => (
            <>
                {notifications.map((notification, index) => (
                    <Styles.Wrapper
                        key={notification.displaySettings?.notificationIndex ?? index}
                        marginTop={getHeight(index)}
                        isFadingOut={!!notification.displaySettings?.isAnimating}
                        transition={!!notification.displaySettings?.isReady}
                        reachoutSidepanelWidth={reachoutSidepanelWidth}
                        onAnimationEnd={() => onTransitionEnd(notification.displaySettings?.notificationIndex ?? index)}
                        ref={(element) => {
                            refs.current[index] = element;
                        }}
                        aria-live="polite"
                    >
                        <Styles.Title>{notification.title}</Styles.Title>
                        <Styles.Text>{notification.description}</Styles.Text>
                    </Styles.Wrapper>
                ))}
            </>
        ),
        // Only update if notifications actually change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [notifications],
    );
};

export default NotificationContainer;
